<!-- 物流详情 -->
<template>
  <img @click="openMini" class="mibiBox"
       src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/businessOrder/goHome1.png"/>
</template>
<script>

import wx from 'weixin-js-sdk';
export default {
  data() {
    return {};
  },
  props: {},
  watch: {},
  components: {},

  computed: {},

  mounted() {
  },

  created() {
  },

  methods: {
    openMini() {
      wx.miniProgram.switchTab({ url: '/pages/home/home?channel=dsckd' });
    }
  },
};
</script>
<style lang="scss" scoped>
.mibiBox {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
}
</style>
